import React from 'react';
import CopyField from '../common/CopyField';
import { useContractState } from '../../context/ContractContext';

export default function ReferralLinkCard() {
  const { userId } = useContractState();
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const link = userId ? `${origin}/?ref=${userId}` : `${origin}/`;
  return (
    <div className="referral-card">
      <div className="label">Your Referral Link</div>
      <div className="value">{userId ? `#${userId}` : 'Register first to get your ID'}</div>
      <CopyField value={link} />
    </div>
  );
}
